export default function GoogleMap() {
  return (
    <div className="rounded-2xl overflow-hidden border border-zinc-800 reveal">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.8479876543212!2d73.162009!3d19.2212296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7943a8e43c3e3%3A0x9f7b6a011a79f3a!2sClassic24%20Digital%20Solutions!5e0!3m2!1sen!2sin!4v1234567890123"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Classic24 Digital Solutions Location"
      />
    </div>
  )
}